/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=250a2058&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident_patient_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250a2058"]])

export default __exports__